import React from "react";
import { NaturatherapyWebManagementMain } from "../pages/NaturatherapyWeb";
import { User } from "../pages/NaturatherapyWeb/types";

interface NaturatherapyWebManagementProps {
  currentUser?: User;
}

const NaturatherapyWebManagement: React.FC<NaturatherapyWebManagementProps> = ({
  currentUser,
}) => {
  return <NaturatherapyWebManagementMain currentUser={currentUser} />;
};

export default NaturatherapyWebManagement;
